import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Avatar, Box, Container, CssBaseline, Typography, TextField,
  IconButton, InputAdornment, Link
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import Iconify from '../components/iconify/Iconify';
import axios from 'axios';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Trooper Live
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function ResetPassword() {
  const { userId, token } = useParams();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = yup.object({
    password: yup.string().required('Password is required').min(6, 'Minimum 6 characters'),
  });

  const formik = useFormik({
    initialValues: { password: '' },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
        try {
  const response = await axios.post(
    `/api/v1/user/password-reset/${userId}/${token}`,
    { password: values.password },
    { headers: { 'Content-Type': 'application/json' } }
  );

  toast.success('Password reset successfully');
  navigate('/login');

} catch (error) {
  if (error.response) {
    toast.error(error.response.data.msg || 'Reset failed');
  } else {
    toast.error('Something went wrong');
  }
}
    },
  });

  return (
    <>
      <Helmet>
        <title> Reset Password | Troopers </title>
      </Helmet>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main', height: '70px', width: '70px' }} />
          <Typography gutterBottom sx={{ margin: '2rem 0' }} variant="h4">
            Reset Password
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              name="password"
              label="New Password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
              margin="normal"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              required
            />

            <LoadingButton
              type="submit"
              fullWidth
              variant="contained"
              loading={formik.isSubmitting}
              disabled={!formik.isValid}
              size="large"
              sx={{ mt: 3 }}
            >
              Reset Password
            </LoadingButton>
          </form>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </>
  );
}
